import UserPurchase from "@skrice.studio/mavia-common/build/models/main/UserPurchase";
import CheckIcon from "@mui/icons-material/Check";
import HistoryIcon from "@mui/icons-material/History";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import {
    Avatar,
    Button,
    CardHeader,
    CircularProgress,
    Dialog,
    DialogTitle,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from "@mui/material";
import axios from "axios";
import moment from "moment";
import * as React from "react";
import { NavLink } from "react-router-dom";
import { Avatar as UserAvatar } from "../../components/Avatar";
import { Config } from "../../config/config";
import { getGlobalVar, Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";

interface Props {
    activeUser: any;
    activeEnv: any;
    classes: any;
    form: any;
}

interface State {
    list: UserPurchase[];
    loaded: boolean;
    recordHistory: {
        open: boolean;
        list: any[];
    };
}

export class Purchases extends React.Component<Props, State> {

    constructor(props) {
        super(props);

        this.state = {
            list: [],
            loaded: false,
            recordHistory: {
                open: false,
                list: [],
            }
        };

        document.title = Helpers.documentTitle("Purchases");
    }

    componentDidMount() {
        this.fetchData();
    }

    headers() {
        return {
            headers: { Authorization: Helpers.getSessionId() },
            timeout: 30000
        }
    }

    async fetchData() {
        try {
            const response = await axios.get(`${Config.getInstance.apiUrl}/api/purchases`, this.headers());
            this.setState({
                list: response.data.list,
                loaded: true,
            });
        } catch (e) {
            PopupMessage.error(e.response.data.message);
        }
    }

    formatDate(date: string | Date) {
        return moment(date).utc().format("DD.MM.YYYY HH:mm:ss");
    }

    displayRecords() {
        if (!this.state.loaded) {
            return <TableRow key="loading-row">
                <TableCell colSpan={8}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        return this.state.list.map(record => {
            const productData = this.getProductData(record.product_id);

            return <TableRow key={record.id}>
                <TableCell>
                    {UserAvatar(record.user)}
                </TableCell>
                <TableCell>
                    <NavLink to={`/players/${record.user.id}`}>
                        {record.user.name}
                    </NavLink>
                </TableCell>
                <TableCell>{record.product_id}</TableCell>
                <TableCell>{productData?.price ? `$${productData.price}` : "Unknown"}</TableCell>
                <TableCell>{record.purchase_status}</TableCell>
                <TableCell>{this.formatDate(record.created_at)}</TableCell>
                <TableCell>{this.formatDate(record.updated_at)}</TableCell>
                <TableCell>
                    <Button disableElevation color="primary" size="small" onClick={() => this.handleOpen(record)} startIcon={<HistoryIcon/>}>
                        History
                    </Button>
                </TableCell>
            </TableRow>;
        });
    }

    getProductData(productId: string) {
        return getGlobalVar("PRODUCT_LIST").find(item => item.productId === productId);
    }

    handleOpen(record) {
        const temp = [...record.history];

        temp.push({
            status: record.purchase_status,
            date: record.updated_at
        });

        this.setState({
            recordHistory: {
                open: true,
                list: temp.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()),
            }
        });
    }
    handleClose() {
        this.setState({
            recordHistory: {
                open: false,
                list: [],
            }
        });
    }

    getRecordAvatar(record) {
        if (record.status === "accepted") {
            return <Avatar style={{ backgroundColor: "#4caf50" }}>
                <CheckIcon/>
            </Avatar>;
        }

        return <Avatar style={{ backgroundColor: "#d32f2f" }}>
            <PriorityHighIcon/>
        </Avatar>
    }

    render() {
        return (
            <div className="contentPadding">
                <Paper elevation={0}>
                    <CardHeader
                        title={`Purchases (${this.state.list.length})`}
                    />
                    <Table className="min-table-size">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{width: 50}}></TableCell>
                                <TableCell>User</TableCell>
                                <TableCell>Product</TableCell>
                                <TableCell>Product Price</TableCell>
                                <TableCell>Current Status</TableCell>
                                <TableCell>First transaction</TableCell>
                                <TableCell>Last update</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.displayRecords()}
                        </TableBody>
                    </Table>
                </Paper>

                <Dialog onClose={() => this.handleClose()} open={this.state.recordHistory.open}>
                    <DialogTitle>Purchase status history</DialogTitle>
                    <List>
                        {this.state.recordHistory.list.map((record, index) => (
                            <ListItem key={record.date} className={index === 0 ? "first-purchase-in-list" : ""}>
                                <ListItemAvatar>
                                    {this.getRecordAvatar(record)}
                                </ListItemAvatar>
                                <ListItemText
                                    primary={Helpers.capitalizeFirstLetter(record.status)}
                                    secondary={this.formatDate(record.date)}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Dialog>
            </div>
        );
    }
}
